<template>
	<div class="container">
		<div class="main_box">
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="title"
			>Abiores</div>
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_1"
			>
				<div class="block_1_main">
					<div class="left">
						<div class="txt">
							Abiores is a subsidiary of Cordx Union (CU), a multinational group corporation well known for R&D, manufacture and marketing of medical devices, headquartered in California, USA. Based on the headquarters in the US, manufacturing bases in China and global business divisions, the group consists of a number of subsidiaries, namely, Coretests Inc., Core Technology, Jtests LLC, Abiores, Bonore Industry, Core Medical, Core Investment, Bao Ruiyuan Biotech, Abiores Technology, Abiores Holding, Abiores Consulting, etc.
						</div>
						<div class="btn" @click="goContact">
							Contact Us&ensp;<van-icon name="down" size="18px" color="#C8000A" style="top: 2.5px;transform: rotate(-90deg);" />
						</div>
					</div>
					<div class="right">
						<img src="../../../assets/img_public/about/block1.webp" />
					</div>
				</div>
			</div>
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_2"
			>
				<div class="block_2_main">
					<div>
					Abiores is a high-tech enterprise specializing in the R&D, production, sales and technical services of in vitro diagnostic (IVD) products. Among its production bases in China, the Fangshan production base located in Bao Ruiyuan Industrial Park, Doudian town, Fangshan District, Beijing, covers an area of 4 hectares and a construction area of more than 30,000 m².The company has an independent R&D center, quality inspection center and GMP plants of grade 100,000 and grade 10,000 (local grade 100) standards, with full sets of molecular diagnostic reagent production lines and corresponding supporting facilities.
					</div>
					<div>
					Abiores now owns Magnetic Beads Technology Platform, Micro Nucleic Acid Releasing Reagent Platform (One-tube Method) and Automated Nucleic Acid Extraction Platform, and has developed fluorescence PCR products for Hepatitis B, Hepatitis C, HIV, hand, foot and mouth disease and respiratory diseases, etc.
					</div>
					<div>
					Adhering to its quality policy of “Perfect Quality, Sincere Service, Standardized Management, Exploration and Innovation” and the aim of creating a first-class biomedical enterprise, Abiores will continuously improve its R&D capacity and production technology level, and make full use of the research achievements in the fields of molecular biology, modern bioengineering technology and biomedicine to provide customers with high-quality products and technical services and serve the cause of human health!
					</div>
				</div>
			</div>
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="300"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_3"
			>
				<div class="block_3_main">
					<div class="left">
						<img src="../../../assets/img_public/about/block2.webp" />
					</div>
					<div class="right">
						<div class="txt">
							Abiores regards its talents as the foundation of the company and the source of profits. It actively introduces high-tech talents both from home and abroad, and attaches importance to the on-the-job training and the improvement of personal value of its employees. Welcome to join us!
						</div>
						<div class="btn" @click="goCorDx">
							About CorDx&ensp;<van-icon name="down" size="18px" color="#C8000A" style="top: 2.5px;transform: rotate(-90deg);" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//跳转联系我们
		goContact() {
			let that = this;
			that.$router.push({ path: '/contact.html' });
		},
		//跳转官网
		goCorDx() {
			window.open('https://cordx.com/about');
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_3{
		background-color: #F7F8FA;
		.block_3_main{
			width: 1200px;
			margin: 0 auto 0px auto;
			padding-bottom: 100px;
			display: flex;
			align-items: center;
			.left:hover{
				img{
					transform: scale(1.2);
				}
			}
			.left{
				flex: 1;
				margin-right: 50px;
				overflow: hidden;
				img{
					width: 100%;
					transition: all 0.6s;
				}
			}
			.right{
				flex: 1;
				padding-left: 50px;
				.btn{
					display: inline-block;
					margin-top: 26px;
					color: #C8000A;
					font-size: 18px;
					cursor: pointer;
				}
				.txt{
					font-size: 18px;
					line-height: 2;
					
				}
			}
		}
	}
	.block_2{
		background-color: #F7F8FA;
		.block_2_main{
			width: 1200px;
			margin: 0px auto;
			padding: 80px 0;
			div{
				font-size: 18px;
				line-height: 2;
				
			}
		}
	}
	.block_1{
		background-color: #F7F8FA;
		.block_1_main{
			width: 1200px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			.right:hover{
				img{
					transform: scale(1.2);
				}
			}
			.right{
				flex: 1;
				margin-left: 50px;
				overflow: hidden;
				img{
					width: 100%;
					transition: all 0.6s;
				}
			}
			.left{
				flex: 1;
				padding-right: 50px;
				.btn{
					display: inline-block;
					margin-top: 26px;
					color: #C8000A;
					font-size: 18px;
					cursor: pointer;
				}
				.txt{
					font-size: 18px;
					line-height: 2;
					
				}
			}
		}
	}
	.title{
		background-color: #F7F8FA;
		padding: 0px 0 80px 0;
		font-size: 44px;
		font-weight: bold;
		text-align: center;
	}
}
</style>